/** @format */

import React, { useState, useEffect } from "react";
import { SERVICE_LABEL_MAP, viewFormConfig } from "./config";
import CancelIcon from "@mui/icons-material/Cancel";
import { Box, Button, Grid, IconButton } from "@mui/material";
import "./index.scss";
import {
  exportToExcel,
  formatDate,
  getFileNameFromUrl,
  splitFileName,
} from "../../utils";
import { DATE_FORMATS, TICKET_STAGES } from "../../utils/constants";
import { FileDownloadOutlined } from "@mui/icons-material";
import PreviewFormGenerator from "../../core/preview-form-generator";
import { getTicketFormRow1 } from "../ticket-form/helper";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { toast } from "react-toastify";
import SiTextField from "../../core/si-textfield";
import { useNavigate } from "react-router-dom";
import CustomButtonComponent from "../../core/custom-button";
import { Icon } from "@iconify/react";
import TicketAttachments from "../../pages/admin/ticket-details-v2/ticket-attachments";
import CustomModal from "../../core/modal";
import ViewAttachments from "./view-attachments";
import EditForm from "./edit-form";
import EditIcon from "@mui/icons-material/Edit";
const ViewTicket = ({ details, onClose, ticketDetails, loadTicketData }) => {
  const [formData, setFormData] = useState({});
  const [comment, setComment] = useState("");
  const [showAttachments, setShowAttachments] = useState(false);
  const [timeline, setTimeline] = useState([]);
  const [isEditForm, setEditForm] = useState(false);
  const navigate = useNavigate();
  const {
    oemEngineLocation = {},
    freeServiceDetails = {},
    pastHistory = [],
    attachmentUrls = [],
  } = details;

  const location =
    oemEngineLocation &&
    `${oemEngineLocation.tractorAddress || ""},${
      oemEngineLocation.pinCode || ""
    }`;
  const downloadExcel = () => {
    const data = [
      {
        Ticket: details.ticketId,
        "Name of OEM": details.oemName,
        "Service Eng Name": details.oemServiceEngineerName,
        "Service Eng Contact": details.oemServiceEngineerContact,
        "Engine Location": location,
        "OEM Dealer Name": details.oemDealerName,
        "Engine Serial Number": details.engineSerialNumber,
        "Unit/Machine Current Status": details.unitMachineStatus,
        "Unit Serial Number": details.unitSerialNumber,
        "Date of Sale": formatDate(
          details.dateOfSale,
          DATE_FORMATS["DD-MM-YYYY"]
        ),
        "Customer Complaint Date": formatDate(
          details.customerComplaintDate,
          DATE_FORMATS["DD-MM-YYYY"]
        ),
        "Customer Complaint Nature": details.natureOfCustomerComplaint,
        HMR: details.hmr,
        "Customer Name": details.customerName,
        "Customer Contact": details.customerContact,
        "Investigation Details By OEM": details.investigationDetailsByOem,
        Remarks: details.remarks,
        "Customer Regular Application": details.customerRegularApplication,
        "Complaint Observed Application":
          details.applicationWhileComplaintObserved,
        "Soil Condition": details.soilCondition,
        Attachments: details.attachments,
      },
    ];
    exportToExcel(data, "Ticket Form");
  };

  const addComments = () => {
    invokeApi(
      HTTP_METHODS.POST,
      `${HOSTNAME}${REST_URLS.OEM_COMMENT}/${details.ticketId}`,
      {
        comment,
      }
    )
      .then((response) => {
        if (response?.message) {
          toast.error("Update Failed");
        } else {
          toast.success("Comment Added");
          setComment("");
        }
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    setFormData({
      oemName: ticketDetails?.oemOrg?.name || details.oemName,
      oemServiceEngineerName: details.oemServiceEngineerName,
      oemServiceEngineerContact: details.oemServiceEngineerContact,
      tractorAddress: oemEngineLocation.tractorAddress,
      state: oemEngineLocation.state,
      city: oemEngineLocation.city,
      pinCode: oemEngineLocation.pinCode,
      oemDealerName: details.oemDealerName,
      cqc: details?.cqc || "",
      cutInNumber: ticketDetails?.cutInNumber,
      engineSerialNumber: details.engineSerialNumber,
      unitSerialNumber: details.unitSerialNumber,
      dateOfSale: formatDate(details.dateOfSale, DATE_FORMATS["DD-MM-YYYY"]),
      customerComplaintDate: formatDate(
        details.customerComplaintDate,
        DATE_FORMATS["DD-MM-YYYY"]
      ),
      natureOfCustomerComplaint: details.natureOfCustomerComplaint,
      unitMachineStatus: details.unitMachineStatus,
      hmr: details.hmr,
      customerName: details.customerName,
      customerContact: details.customerContact,
      investigationDetailsByOem: details.investigationDetailsByOem,
      remarks: details.remarks,
      customerRegularApplication: details.customerRegularApplication,
      actionTakenByOem: details.actionTakenByOem,
      applicationWhileComplaintObserved:
        details.applicationWhileComplaintObserved,
      soilCondition: details.soilCondition,
    });
  }, [ticketDetails]);

  return (
    <div className="page-load">
      <Grid container spacing={3}>
        <Grid item md={9} sx={{ mt: 3 }}>
          <div className="form-con" style={{ margin: "0px", width: "100%" }}>
            {/* {!isEditForm && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <IconButton onClick={() => setEditForm(true)} sx={{ p: 0 }}>
                  <EditIcon />
                </IconButton>
              </Box>
            )} */}
            {isEditForm ? (
              <EditForm
                ticketForm={formData}
                details={details}
                setEditForm={setEditForm}
                loadTicketData={loadTicketData}
              />
            ) : (
              <div>
                <PreviewFormGenerator
                  formConfig={viewFormConfig}
                  formValues={formData}
                />
                <Grid container>
                  <Grid item md={6} xs={12}>
                    {Object.keys(freeServiceDetails).length > 0 && (
                      <div>
                        <p className="primary-text">Free Services</p>
                        <div className="free-services">
                          {Object.keys(freeServiceDetails).length > 0 && (
                            <div className="service-row table-head-bg">
                              <div>Service</div>
                              <div>Date</div>
                              <div>Hours</div>
                            </div>
                          )}

                          {Object.keys(freeServiceDetails).map((key) => {
                            return (
                              <div
                                className={
                                  key === "firstService" &&
                                  freeServiceDetails[key]["runningHours"] > 50
                                    ? "service-row error"
                                    : "service-row"
                                }
                              >
                                <div>{SERVICE_LABEL_MAP[key]}</div>
                                <span>
                                  {formatDate(
                                    freeServiceDetails[key]["date"],
                                    DATE_FORMATS["DD-MM-YYYY"]
                                  )}
                                </span>
                                <div>
                                  {freeServiceDetails[key]["runningHours"]}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </Grid>
                  <Grid item md={6}>
                    {pastHistory.length > 0 && (
                      <div>
                        <p className="primary-text">Past History</p>
                        <div className="free-services">
                          {pastHistory.length > 0 && (
                            <div className="service-row table-head-bg">
                              <div>Date Of Failure</div>
                              <div>Complaint Reported</div>
                              <div>Hours</div>
                            </div>
                          )}
                          {pastHistory.map((h) => {
                            return (
                              <div className="service-row">
                                <span>
                                  {formatDate(
                                    h.dateOfFailure,
                                    DATE_FORMATS["DD-MM-YYYY"]
                                  )}
                                </span>
                                <div>{h.complaintReported}</div>
                                <div>{h.hours}</div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </Grid>
                </Grid>
                {attachmentUrls?.length > 0 && (
                  <div>
                    <p className="primary-text">Attachments</p>
                    <div className="t-files" style={{ margin: "20px 0px" }}>
                      {attachmentUrls?.map((url, index) => {
                        return (
                          <div key={index}>
                            <a
                              href={splitFileName(url)}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                {getFileNameFromUrl(url, 25)}
                              </Box>
                            </a>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </Grid>
        <Grid item md={3} xs={12}>
          <div
            className="form-con"
            style={{ paddingRight: "30px", width: "100%" }}
          >
            <p className="form-header"> View/ Download </p>
            <Box sx={{ display: "flex" }}>
              <CustomButtonComponent
                variant="contained"
                color="primary"
                onClick={downloadExcel}
                fullWidth
                sx={{ mr: 2 }}
                startIcon={
                  <Icon
                    icon="solar:download-bold-duotone"
                    width="1.2rem"
                    height="1.2rem"
                    style={{ color: "white" }}
                  />
                }
              >
                Download
              </CustomButtonComponent>
              <CustomButtonComponent
                variant="contained"
                onClick={() => setShowAttachments(true)}
                fullWidth
              >
                View Attachments
              </CustomButtonComponent>
            </Box>

            <div className="action-form">
              <div>
                <p>Add Comment</p>
                <SiTextField
                  value={comment}
                  placeholder="Add Comments"
                  multiline
                  rows={5}
                  variant="outlined"
                  onChange={(e) => setComment(e.target.value)}
                />
                <div className="add-comment-bts">
                  <CustomButtonComponent
                    variant="contained"
                    color="primary"
                    onClick={addComments}
                    disabled={!comment}
                    fullWidth
                    startIcon={
                      <Icon
                        icon="iconamoon:comment-dots-duotone"
                        width="1.2rem"
                        height="1.2rem"
                        style={
                          !comment ? { display: "none" } : { color: "white" }
                        }
                      />
                    }
                  >
                    Add Comment
                  </CustomButtonComponent>
                </div>
              </div>
            </div>
            {ticketDetails.stage ===
              TICKET_STAGES.ENGINE_REPLACEMENT_APPROVED && (
              <div>
                <p className="form-header" style={{ marginTop: "20px" }}>
                  Add FOC
                </p>
                <CustomButtonComponent
                  variant="contained"
                  color="primary"
                  onClick={() => navigate(`/oem/foc-form/${details.ticketId}`)}
                  fullWidth
                >
                  FOC
                </CustomButtonComponent>
              </div>
            )}
            {ticketDetails?.jointInspectionReport?.status === "PUBLISHED" && (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <CustomButtonComponent
                  variant="contained"
                  fullWidth
                  onClick={() => navigate(`/oem/jir/${details.ticketId}`)}
                >
                  JIR
                </CustomButtonComponent>
              </Box>
            )}
          </div>
        </Grid>
      </Grid>
      {showAttachments && (
        <CustomModal
          title="Conversations"
          onClose={() => setShowAttachments(false)}
          contentClassName="form-modal"
        >
          {showAttachments && (
            <TicketAttachments
              ticketDetails={ticketDetails}
              timeline={timeline}
            />
          )}
          {/* <ViewAttachments ticketDetails={ticketDetails} timeline={timeline} /> */}
        </CustomModal>
      )}
    </div>
  );
};

export default ViewTicket;
